import { render, staticRenderFns } from "./BannerSection.vue?vue&type=template&id=36f5e3ef&scoped=true&"
import script from "./BannerSection.vue?vue&type=script&lang=js&"
export * from "./BannerSection.vue?vue&type=script&lang=js&"
import style0 from "./BannerSection.vue?vue&type=style&index=0&id=36f5e3ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5e3ef",
  null
  
)

export default component.exports